var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleLinkedinFill = function SvgCircleLinkedinFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 75Q150 0 256 0t181 75 75 181q0 70-34.5 128.5t-93 93T256 512q-106 0-181-75T0 256 75 75m84 147v134h42V222zm38-59q-7-7-17-7t-17 7-7 17 7 17 17 7 17-7 7-17-7-17m30 59v134h41v-66q0-34 25-34 10 0 15 6t6 12 1 17v65h41v-73q0-20-3.5-33t-15-22-31.5-9q-27 0-39 22v-19z"
  })));
};
export default SvgCircleLinkedinFill;